import { Divider } from "antd";
import React, { useState } from "react";
import JoinWaitlistModal from "../JoinWaitlist";
import { Link } from "react-router-dom";

const MobileNavMenuItem = ({ label, link, index, closeDrawer, last }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancel = () => setIsModalOpen(false);

  return (
    <>
      <div className="mobile-nav-menu-item-container">
        <Link to={link}>
          <p
            className="mobile-nav-menu-item text-condensed"
            onClick={closeDrawer}
          >
            {label}
          </p>
        </Link>
        {index === last ? (
          <div className="nav-actions">
            <button
              className="contained_button"
              onClick={() => {
                setIsModalOpen(true);
                closeDrawer();
              }}
            >
              Get Started
            </button>
            <a
              href="https://candidate.stealthjobs.co/"
              target="_blank"
              rel="noreferrer"
            >
              <button className="outlined_button">Sign In</button>
            </a>
          </div>
        ) : (
          <Divider />
        )}
      </div>
      <JoinWaitlistModal
        isModalOpen={isModalOpen}
        handleOk={handleCancel}
        handleCancel={handleCancel}
        defaultValue="seeker"
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default MobileNavMenuItem;
